import React, { useEffect, useState } from "react";
import Swal from "sweetalert2";
import styles from "./index.module.scss";
import VideoPanel from "../../VideoPanel";
import GameBG from "../../GameBG";
import EPage from "../../../utils/EPage";
import ActionID from "../../../utils/ActionID";
import RemoteServer from "../../../utils/RemoteServer";
import AppCtrl from "../../../control/AppCtrl";
import Utils from "../../../utils/Utils";
import LANGUAGE_TYPE from "../../../utils/Language";
import CryptoJS from "../../../utils/crypto-js.min";
import ScreenOrientation from "../../../utils/Orientation";
import useUserCoins from "../../../redux/userCoins/userCoinsAction";
import useScoreMsg from "../../../redux/scoreMsg/scoreMsgAction";
import useGameplay from "../../../redux/gameplay/gameplayAction";
import useBetWin from "../../../redux/betWinData/betWinAction";
import useBroadcasts from "../../../redux/broadcasts/broadcastsAction";
import useAlert from "../../../hook/useAlert";

const uiBtnHoldType = {
  LongPress: 0,
  Usual: 1,
  Pinpon: 2,
  LongPress_In1Sec: 3,
  Pinpon_In1Sec: 4,
};
const uiElements = {
  machine: {},
  others: {},
  btns: {},
};
var mGameBtns = {};
var mGameOthers = {};
var mSingleInScore = 100;
var mInScoreNum = 1;
var mScoreMsgTimeout = null;
var mCheckCheckReconnect = null;
var mVideoUINum = 0;
var mVideoUIIndex = 0;
var isFullscreenInBonusView = true;
var isKeyboardEnable = true;
var mSpyTimeout = null;
var mHereAnimation = null;
var mTianjing = null;
var mLastReloadTime = new Date(0);

function GameSpyClassic() {
  // 新增 protocol 的 useRef
  const protocolRef = useRef('http');
  const { userCoins } = useUserCoins();
  const { gameplay } = useGameplay();
  const { betWinData } = useBetWin();
  const { broadcasts } = useBroadcasts();
  const { scoreMsg } = useScoreMsg();
  const { showAlert } = useAlert();

  const bgImgId = "spyBG";
  const defGameBtnStatusUP = 0;
  const defGameBtnStatusDOWN = 1;
  const defGameBtnStatusDOWN_HOLD = 2;
  const videoIds = [
    {
      id: "videoScreen0",
      iframe: "gameVideo",
    },
    {
      id: "videoScreen1",
      iframe: "gameVideo1",
    },
    {
      id: "videoScreen2",
      iframe: "gameVideo2",
    },
  ];
  const videoInfo = [];

  //===========================================================================
  const [roundIndex, setRoundIndex] = useState(0);

  // 在 useEffect 中初始化 protocol
  useEffect(() => {
    const getProtocol = () => {
      try {
        const middleServer = AppCtrl.middleServer();
        return middleServer && middleServer.getProtocol ? middleServer.getProtocol() : 'http';
      } catch (error) {
        console.warn('Failed to get protocol from AppCtrl, using default http:', error);
        return 'http';
      }
    };
    
    protocolRef.current = getProtocol();
  }, []); // 只在組件掛載時執行一次

  useEffect(() => {
    componentDidMount();
    return componentWillUnmount;
  }, []);

  useEffect(() => {
    updateUserCoins(userCoins);
  }, [userCoins]);

  useEffect(() => {
    updateMsg(scoreMsg);
  }, [scoreMsg]);

  useEffect(() => {
    updateGameplay(gameplay);
  }, [gameplay]);

  useEffect(() => {
    updateBetWin(betWinData);
  }, [betWinData]);

  useEffect(() => {
    updateBroadcasts(broadcasts);
  }, [broadcasts]);
  //===========================================================================

  function componentDidMount() {
    mbLoadRotatAnimation = false;
    const machineInfo = AppCtrl.spyMachineInfo();
    const deviceWidth = window.innerWidth;
    const deviceHeight = window.innerHeight;

    const uiMainArea = document.getElementById("mainArea");
    //Loading Gif
    if (uiMainArea) {
      const uiLoadingMask = document.createElement("img"); //new Image();
      uiLoadingMask.id = "loadingmask";
      uiLoadingMask.type = "image";
      uiLoadingMask.src = "img/ChooseMachine/Loading.gif";
      //uiLoadingMask.name = 'submit';
      uiLoadingMask.style.position = "absolute";
      uiLoadingMask.style.left = "50%";
      uiLoadingMask.style.top = "50%";
      uiLoadingMask.style.width = "100%";
      uiLoadingMask.style.height = "100%";
      uiLoadingMask.style.transform = "translate(-50%,-50%)";
      uiLoadingMask.style.display = "";
      uiMainArea.appendChild(uiLoadingMask);
    }
    const checkOrientation = AppCtrl.CheckOrientation();
    if (checkOrientation) {
      AppCtrl.SetOrientation(ScreenOrientation.LandscapePrimary);
    }

    isFullscreenInBonusView = AppCtrl.isFullscreenInBonusView();
    isKeyboardEnable = AppCtrl.isKeyboardEnable();
    mSingleInScore = machineInfo.singleInScore;

    buildGameUI(deviceWidth, deviceHeight, machineInfo.gameUI);
    registerEvent();

    videoInfo.splice(0, videoInfo.length);
    for (let i = 0; i < videoIds.length; i++) {
      const uiVideoFrame = document.getElementById(videoIds[i].id);
      if (uiVideoFrame)
        uiVideoFrame.style.display = i < mVideoUINum ? "" : "none";

      videoInfo.push({
        angle: machineInfo.videoInfos[i].rotate,
        cameraScale: machineInfo.videoInfos[i].scale,
        source: machineInfo.videoInfos[i].source,
      });
    }
    mVideoUIIndex = 0;
    for (let i = 0; i < mVideoUINum; i++) {
      startVideo(i, videoInfo[i].source, videoInfo[i].angle);
    }

    // exit spy after 30 seconds
    const exitSeconds = 30;
    mSpyTimeout = setTimeout(function () {
      mSpyTimeout = null;
      exitConfirmed();
    }, exitSeconds * 1000);
  }

  function componentDidUpdate() {}

  function componentWillUnmount() {
    const checkOrientation = AppCtrl.CheckOrientation();
    if (checkOrientation) {
      AppCtrl.FreeOrientation();
    }
    for (let i = 0; i < mVideoUINum; i++) {
      stopVideo(i);
    }
    unregisterEvent();
    // reset
    uiElements.machine = {};
    uiElements.others = {};
    uiElements.btns = {};
    if (mSpyTimeout) {
      clearTimeout(mSpyTimeout);
      mSpyTimeout = null;
    }
  }

  function intToString(value) {
    let strValue = "0";
    if (value) {
      let prefix = "";
      if (value < 0) {
        prefix = "-";
        value = -value;
      }
      let arrValue = [];
      while (value > 0) {
        arrValue.push(value % 1000);
        value = Math.floor(value / 1000);
      }
      if (arrValue.length > 0) arrValue.reverse();
      else arrValue.push(0);

      strValue = `${prefix}${arrValue[0]}`;
      for (let i = 1; i < arrValue.length; i++) {
        let value = arrValue[i];
        if (value === 0) strValue += `,000`;
        else if (value < 10) strValue += `,00${value}`;
        else if (value < 100) strValue += `,0${value}`;
        else strValue += `,${value}`;
      }
    }
    return strValue;
  }

  function onInScoreTimesChanged(select) {
    if (!select) return;

    const id = select.id;
    console.log(`id;${id}`);
    mInScoreNum = parseInt(select.value);

    const uiPoint = uiElements.others["point"];
    if (uiPoint) uiPoint.innerHTML = intToString(mInScoreNum * mSingleInScore);
  }

  function updateUserCoins(userCoins) {
    const machine = AppCtrl.spyingMachine();
    const coins =
      machine && !machine.isTrial ? userCoins.coins : userCoins.trialCoins;
    const wainZhus = userCoins.wainZhus;

    const uiScore = uiElements.others["score"];
    if (uiScore) uiScore.innerHTML = intToString(coins);
  }

  function updateMsg(msg) {
    const uiScoreMsg = uiElements.others["scoremsg"];
    if (uiScoreMsg && uiScoreMsg.innerHTML != msg) {
      AppCtrl.setScoreMsg(msg);
      //
      if (mScoreMsgTimeout) clearTimeout(mScoreMsgTimeout);
      mScoreMsgTimeout = setTimeout(function () {
        mScoreMsgTimeout = null;
        AppCtrl.setScoreMsg("");
      }, 5000);
    }
  }

  function updateGameplay(obj) {}

  function updateBroadcasts(obj) {}

  function setGameBtnStatus(btnId, status) {
    const lockedMachine = AppCtrl.lockedMachine();
    if (lockedMachine) {
      const gameBtn = mGameBtns[btnId];
      // if btn sytatus is same, skip it.
      if (gameBtn && gameBtn.btnStatus !== status) {
        const middleServer = AppCtrl.middleServer();
        const machineInfo = AppCtrl.spyMachineInfo();
        const folderName = machineInfo.gameUI["foldername"];
        gameBtn.btnStatus = status;
        // send request tp lobby manager
        const obj = new Object();
        switch (status) {
          case defGameBtnStatusUP:
            obj["Action"] = ActionID.GameBtnUp;
            obj["ConnectionId"] = middleServer.connectionId();
            gameBtn.btn.src = `./uilayout/${folderName}/${
              gameBtn.Img
            }?${Math.random()}`;
            break;
          case defGameBtnStatusDOWN:
          case defGameBtnStatusDOWN_HOLD:
            obj["Action"] = ActionID.GameBtnDown;
            obj["ConnectionId"] = middleServer.connectionId();
            gameBtn.btn.src = `./uilayout/${folderName}/${
              gameBtn.ImgDown
            }?${Math.random()}`;
            break;
        }

        obj["DeviceId"] = lockedMachine.deviceId;
        obj["MachineId"] = lockedMachine.machineId;
        obj["BtnId"] = gameBtn.Index;
        obj["BtnText"] = gameBtn.btn.id;
        if (gameBtn.btn.id == "開分" || gameBtn.btn.id == "洗分") {
          obj["InScoreNum"] = mInScoreNum;
        }
        AppCtrl.sendRequestAction(obj, RemoteServer.WinLobbyManager);
      }
    }
  }

  function onGameBtnDown(e) {
    let btnId = null;
    let gameBtn;
    if (e.type == "keydown") {
      const key = e.key;

      for (let id in mGameBtns) {
        gameBtn = mGameBtns[id];
        if (key == gameBtn.Keyboard) {
          btnId = id;
          break;
        }
      }
      if (btnId === null || !gameBtn) return;

      console.log(`onGameBtnDown-Keyboard key=${e}.key},code=${e.code}`);
    } else {
      btnId = e.target.id;
      gameBtn = mGameBtns[btnId];
      if (!gameBtn) return;
      console.log("onGameBtnDown");
    }

    // game btn down
    switch (gameBtn.btnHoldType) {
      case uiBtnHoldType.LongPress: //長壓
        if (gameBtn.btnStatus !== defGameBtnStatusDOWN_HOLD)
          setGameBtnStatus(btnId, defGameBtnStatusDOWN_HOLD);
        else setGameBtnStatus(btnId, defGameBtnStatusUP);
        break;
      case uiBtnHoldType.Usual: //一般
        setGameBtnStatus(btnId, defGameBtnStatusDOWN);
        break;
      case uiBtnHoldType.Pinpon: //脈衝
        let intervalPinpon = (gameBtn.pinponTimerInterval != null && gameBtn.pinponTimerInterval != 0) ? gameBtn.pinponTimerInterval : 500;
        if (!gameBtn.pinponTimer) {
          gameBtn.pinponTimer = setInterval(function () {
            if (gameBtn.btnStatus === defGameBtnStatusDOWN)
              setGameBtnStatus(btnId, defGameBtnStatusUP);
            else setGameBtnStatus(btnId, defGameBtnStatusDOWN);
          }, intervalPinpon);
        } else {
          clearInterval(gameBtn.pinponTimer);
          gameBtn.pinponTimer = null;
          setGameBtnStatus(btnId, defGameBtnStatusUP);
        }
        break;
      case uiBtnHoldType.LongPress_In1Sec: //一秒後長壓
        if (gameBtn.btnStatus !== defGameBtnStatusDOWN_HOLD) {
          setGameBtnStatus(btnId, defGameBtnStatusDOWN_HOLD);
          // set timeoutLongPressed to check hold action
          if (gameBtn.timeoutLongPressed)
            clearTimeout(gameBtn.timeoutLongPressed);
          gameBtn.timeoutLongPressed = setTimeout(function () {
            gameBtn.timeoutLongPressed = null;
          }, 1000);
        } else {
          setGameBtnStatus(btnId, defGameBtnStatusUP);
        }
        break;
      case uiBtnHoldType.Pinpon_In1Sec: //一秒後脈衝
        let intervalPinpon_In1Sec = (gameBtn.pinponTimerInterval != null && gameBtn.pinponTimerInterval != 0) ? gameBtn.pinponTimerInterval : 500;
        if (!gameBtn.pinponTimer) {
          setGameBtnStatus(btnId, defGameBtnStatusDOWN_HOLD);
          // set timeoutLongPressed to check hold action
          if (gameBtn.timeoutLongPressed)
            clearTimeout(gameBtn.timeoutLongPressed);
          gameBtn.timeoutLongPressed = setTimeout(function () {
            gameBtn.timeoutLongPressed = null;
            // trigger pinponTimer
            gameBtn.pinponTimer = setInterval(function () {
              if (gameBtn.btnStatus === defGameBtnStatusDOWN)
                setGameBtnStatus(btnId, defGameBtnStatusUP);
              else setGameBtnStatus(btnId, defGameBtnStatusDOWN);
            }, intervalPinpon_In1Sec);
          }, 1000);
        } else {
          clearInterval(gameBtn.pinponTimer);
          gameBtn.pinponTimer = null;
          setGameBtnStatus(btnId, defGameBtnStatusUP);
        }
        break;
      default:
        console.log(
          `onGameBtnDown() unsupported btnHoldType: ${gameBtn.btnHoldType}`
        );
        break;
    }
    //預防常壓按鈕後跳出下載圖片事件
    e.preventDefault();
  }

  function onGameBtnUp(e) {
    let btnId;
    let gameBtn;
    if (e.type == "keyup") {
      const key = e.key;
      let bfind = false;

      for (let id in mGameBtns) {
        gameBtn = mGameBtns[id];
        if (key == gameBtn.Keyboard) {
          bfind = true;
          btnId = id;
          break;
        }
      }
      if (bfind === false || !gameBtn) return;

      console.log(`onGameBtnUp-Keyboard key=${e}.key},code=${e.code}`);
    } else {
      btnId = e.target.id;
      gameBtn = mGameBtns[btnId];
      if (!gameBtn) return;
      console.log("onGameBtnUp");
    }

    // game btn up
    switch (gameBtn.btnHoldType) {
      case uiBtnHoldType.LongPress: //長壓
        // do nothing
        break;
      case uiBtnHoldType.Usual: //一般
        setGameBtnStatus(btnId, defGameBtnStatusUP);
        break;
      case uiBtnHoldType.Pinpon: //脈衝
        // do nothing
        break;
      case uiBtnHoldType.LongPress_In1Sec: //一秒後長壓
        if (gameBtn.timeoutLongPressed) {
          clearTimeout(gameBtn.timeoutLongPressed);
          gameBtn.timeoutLongPressed = null;
          // cancel long press
          setGameBtnStatus(btnId, defGameBtnStatusUP);
        }
        break;
      case uiBtnHoldType.Pinpon_In1Sec: //一秒後脈衝
        if (gameBtn.timeoutLongPressed) {
          clearTimeout(gameBtn.timeoutLongPressed);
          gameBtn.timeoutLongPressed = null;
          // cancel pinponTimer
          setGameBtnStatus(btnId, defGameBtnStatusUP);
        }
        break;
      default:
        console.log(
          `onGameBtnUp() unsupported btnHoldType: ${gameBtn.btnHoldType}`
        );
        break;
    }
  }

  function onResize() {
    const machineInfo = AppCtrl.spyMachineInfo();
    const deviceWidth = window.innerWidth;
    const deviceHeight = window.innerHeight;

    buildGameUI(deviceWidth, deviceHeight, machineInfo.gameUI);
  }

  function checkReconnect() {
    // update mLastReloadTime to avoid trigger new doReload
    mLastReloadTime = new Date();
    //
    if (mCheckCheckReconnect) clearTimeout(mCheckCheckReconnect);
    mCheckCheckReconnect = setTimeout(function () {
      mCheckCheckReconnect = null;

      const middleServer = AppCtrl.middleServer();
      if (middleServer.isConnected()) {
        const language = AppCtrl.getLanguage();
        const uiExit = document.getElementById("exit");
        if (uiExit) {
          uiExit.style.opacity = 1;
          uiExit.disabled = false;
        }

        let msg = "";
        switch (language) {
          case LANGUAGE_TYPE.zh_TW:
            msg = "連線成功";
            break;
          case LANGUAGE_TYPE.en_US:
          default:
            msg = "Connect Success!";
            break;
        }
        AppCtrl.setScoreMsg(msg);
        updateMsg(msg);
        // reload done, so reset mLastReloadTime
        mLastReloadTime = new Date(0);
      } else {
        checkReconnect();
      }
    }, 200);
  }

  function doReload() {
    //doReload
    const curTime = new Date();
    const ts = curTime - mLastReloadTime;
    if (ts > 3000) {
      mLastReloadTime = curTime;

      for (let i = 0; i < mVideoUINum; i++) {
        stopVideo(i);
      }
      const uiExit = document.getElementById("exit");
      if (uiExit) {
        uiExit.style.opacity = 0.3;
        uiExit.disabled = true;
      }
      // proceed reconnect
      AppCtrl.reconnectToServer(function () {
        if (isFullscreenInBonusView) {
          for (let i = 0; i < mVideoUINum; i++) {
            startVideo(i, videoInfo[i].source, videoInfo[i].angle);
            const uiView = document.getElementById(videoIds[i].id);
            if (uiView) uiView.hidden = i != 2 ? false : true;
          }
          mMSDisplayIndex = 0;
        } else {
          const uiIndex = mVideoUIIndex;
          // switch to original view layout
          for (let i = uiIndex; i < mVideoUINum; i++) {
            switchView();
          }
          // restart videos
          for (let i = 0; i < mVideoUINum; i++) {
            startVideo(i, videoInfo[i].source, videoInfo[i].angle);
          }
          // back to users' lastest view layout
          for (let i = 0; i < uiIndex; i++) {
            switchView();
          }
        }

        checkReconnect();
      });
    }
  }

  function exitConfirmed() {
    const language = AppCtrl.getLanguage();
    // proceed unlock machine
    AppCtrl.unlockSpyMachine();
    isFullScreen = false;
    //exitFullScreen();
    // show popup
    let msg = "";
    switch (language) {
      case LANGUAGE_TYPE.zh_TW:
        msg = `正在回到大廳\n請稍候。`;
        break;
      case LANGUAGE_TYPE.en_US:
      default:
        msg = `Back to lobby\nplease wait.`;
        break;
    }
    showAlert({ title: msg, showConfirmButton: false, timer: 4000 });
    // AppCtrl.popup(msg);
    // delay for LobbyManager finishes UnlockMachine
    setTimeout(function () {
      AppCtrl.switchPage(EPage.lobby);
      // navigate('/lobbyPage');
    }, 1500);
  }

  function exitCanceled() {
    // Swal.fire({
    // 	title: '請繼續進行遊戲',
    // 	text: '',
    // 	icon: 'success',
    // 	confirmButtonText: '關閉'
    //   });
  }

  function exit(e) {
    const language = AppCtrl.getLanguage();

    let message = "";
    let text = "";
    let conformText = "";
    let cancelText = "";
    switch (language) {
      case LANGUAGE_TYPE.zh_TW:
        message =
          '<div style={{top:"40px", color:"#ffffff"}}>' +
          "<h1>請注意!!!</h1>" +
          "<h2>本遊戲為實體機台，您將離開觀戰!!!</h2>" +
          "</div>";
        text = "確定要離開遊戲嗎??";
        conformText = "確定離開";
        cancelText = "繼續遊戲";
        break;
      case LANGUAGE_TYPE.en_US:
      default:
        message =
          '<div style={{top:"40px", color:"#ffffff"}}>' +
          "<h1>Notice!!!</h1>" +
          "<h2>You will exit the spy view.</h2>" +
          "</div>";
        text = "Exit??";
        conformText = "OK";
        cancelText = "Cancel";
        break;
    }
    //do confirm
    showAlert({
      title: message,
      text: text,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: conformText,
      cancelButtonText: cancelText,
      confirmCb: function () {
        exitConfirmed();
      },
      cancelCb: function () {
        exitCanceled();
      },
    });
    // Swal.fire({
    //   title: message,
    //   text: text,
    //   icon: "warning",
    //   showCancelButton: true,
    //   confirmButtonColor: "#d33",
    //   cancelButtonColor: "#3085d6",
    //   confirmButtonText: conformText,
    //   cancelButtonText: cancelText,
    // }).then(function (result) {
    //   if (result.isConfirmed) {
    //     exitConfirmed();
    //   } else {
    //     exitCanceled();
    //   }
    // });

    //預防常壓按鈕後跳出下載圖片事件
    e.preventDefault();
    /*
        document.getElementById('demo').onclick = function changeContent() {

            document.getElementById('demo').textContent = "Help me";
        document.getElementById('demo').style = "Color: red";

            }
        <input type="button" className={styles.button} id="login" value="登入" onClick={onLoginClick} />
        title: `<button id="exitConfirmed" className={styles.button}  onClick={exitConfirmed}>確定離開 </button>
                <button id="exitCanceled" className={styles.button}   onClick={exitCanceled}>繼續遊戲 </button>` + message,

                <button id="btnRefresh" className={styles.button} onClick={onRefresh}>重新載入網頁</button>
                */
  }

  function setBGImg(imgUrl, boundary, folderName) {
    const element = document.getElementById(bgImgId);
    if (element) {
      element.src = `./uilayout/${folderName}/${imgUrl}?${Math.random()}`;
      element.style.position = "absolute";
      element.style.left = "0px";
      element.style.top = "0px";
      element.style.width = `${boundary.w}px`;
      element.style.height = `${boundary.h}px`;
    }
  }

  function setMachine(machine, boundary, folderName) {
    if (machine.hasOwnProperty("bgImg")) {
      const bgImg = machine["bgImg"];
      if (bgImg) setBGImg(bgImg, boundary, folderName);
    }
  }

  function createSelect(folderName, config) {
    const id = config["id"];
    const items = config["items"].split(",");
    const element = document.createElement("select");
    element.id = id;
    for (let i = 0; i < items.length; i++) {
      const option = document.createElement("option");
      option.value = items[i];
      option.innerHTML = `開分${items[i]}次`;
      element.appendChild(option);
    }
    element.addEventListener("change", function (e) {
      onInScoreTimesChanged(e.target);
    });

    return element;
  }

  function createPoint(config) {
    const id = config["id"];
    const element = document.createElement("div");
    element.id = id;
    element.innerHTML = "";
    element.style.textAlign = "right";
    element.style.color = "#FFFFFF";
    return element;
  }

  function createScore(config) {
    const id = config["id"];
    const element = document.createElement("div");
    element.id = id;
    element.innerHTML = "";
    element.style.textAlign = "right";
    element.style.color = "#FFFFFF";
    return element;
  }

  function createScoreMsg(config) {
    const id = config["id"];
    const element = document.createElement("div");
    element.id = id;
    element.innerHTML = "";
    element.style.textAlign = "right";
    element.style.color = "#FFFFFF";
    return element;
  }

  function createReload(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", doReload);
    return element;
  }

  function createExit(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", exit);
    return element;
  }

  function createFullscreen(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", fullscreen);
    return element;
  }

  function createPopscreen(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", popScreen);
    return element;
  }

  function createView(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    element.addEventListener("click", switchView);
    return element;
  }

  function createMachineTitle(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("div");
    element.id = id;
    const show = config["text"];
    const machine = AppCtrl.spyingMachine();

    if (show != "false") {
      const bgImage = document.createElement("img");
      bgImage.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
      bgImage.style.position = "absolute";
      bgImage.style.left = "0px";
      bgImage.style.top = "0px";
      bgImage.style.width = "100%";
      bgImage.style.height = "100%";
      element.appendChild(bgImage);

      const text = document.createElement("div");
      text.style.position = "absolute";
      text.style.left = "0px";
      text.style.top = "0px";
      text.style.width = "100%";
      text.style.height = "100%";
      text.style.textAlign = "center";
      text.style.fontSize = "20px";

      text.innerHTML = machine.MachineName;
      element.appendChild(text);
    } else {
      element.innerHTML = machine.MachineName;
      element.style.textAlign = "center";
      element.style.color = "#FFFFFF";
    }

    return element;
  }

  function createAccountTitle(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("div");
    element.id = id;
    const show = config["text"].toLowerCase();
    const uiAccount = AppCtrl.getAccount();

    if (show != "false") {
      const bgImage = document.createElement("img");
      bgImage.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
      bgImage.style.position = "absolute";
      bgImage.style.left = "0px";
      bgImage.style.top = "0px";
      bgImage.style.width = "100%";
      bgImage.style.height = "100%";
      element.appendChild(bgImage);

      const text = document.createElement("div");
      text.style.position = "absolute";
      text.style.left = "0px";
      text.style.top = "0px";
      text.style.width = "100%";
      text.style.height = "100%";
      text.style.textAlign = "center";
      text.style.fontSize = "20px";

      text.innerHTML = uiAccount;
      element.appendChild(text);
    } else {
      element.innerHTML = uiAccount;
      element.style.textAlign = "center";
      element.style.color = "#FFFFFF";
    }

    return element;
  }

  function createImg(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("Img");
    element.id = id;
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    return element;
  }

  function createCoin(folderName, config) {
    const machine = AppCtrl.spyingMachine();
    const id = config["id"];
    const img = config["Img"];
    const imgDown = config["ImgDown"];
    const element = document.createElement("Img");
    element.id = id;
    if (!machine.isTrial)
      element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    else element.src = `./uilayout/${folderName}/${imgDown}?${Math.random()}`;
    return element;
  }

  function createHere(folderName, config) {
    const machine = AppCtrl.lockedMachine();
    const id = config["id"];
    const img = config["Img"];
    const imgDown = config["ImgDown"];
    const element = document.createElement("Img");
    element.id = id;
    if (!machine.Trial)
      element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    else element.src = `./uilayout/${folderName}/${imgDown}?${Math.random()}`;
    return element;
  }

  function createImgBtn(folderName, config) {
    const id = config["id"];
    const img = config["Img"];
    const element = document.createElement("input");
    element.id = id;
    element.type = "image";
    element.src = `./uilayout/${folderName}/${img}?${Math.random()}`;
    element.name = "submit";
    return element;
  }

  function setGameOthers(gameothers, boundary, folderName, uiMainArea) {
    // do sort to make sure the order are matched to manager's prefered order
    gameothers.sort(function (a, b) {
      if (a.index < b.index) return -1;
      else return 1;
    });

    // reset screen number
    mVideoUINum = 0;
    let bPopScreen = false;
    for (let i = 0; i < gameothers.length; i++) {
      const obj = gameothers[i];
      let id = obj.hasOwnProperty("id")
        ? obj["id"].toString().toLowerCase()
        : null;
      let keyboard = obj.hasOwnProperty("Keyboard") ? obj["Keyboard"] : "";
      let img = obj.hasOwnProperty("Img") ? obj["Img"] : "";
      let imgDown = obj.hasOwnProperty("ImgDown") ? obj["ImgDown"] : "";
      let zIndex = obj.hasOwnProperty("zIndex") ? obj["zIndex"] : 0;

      // skip null id obj
      if (!id) continue;
      // sync id
      else obj["id"] = id;

      if (id == "screen" || id == "screen1" || id == "screen2") {
        // increase video number
        mVideoUINum++;
      }

      let element = null;
      let eventID = "onOtherBtnDown";
      if (!uiElements.others[id]) {
        // create element
        switch (id) {
          case "selector":
            element = createSelect(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
          case "point":
            element = createPoint(obj);
            uiMainArea.appendChild(element);
            break;
          case "score":
            element = createScore(obj);
            uiMainArea.appendChild(element);
            break;
          case "scoremsg":
            element = createScoreMsg(obj);
            uiMainArea.appendChild(element);
            break;
          case "reload":
            element = createReload(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
          case "exit":
            element = createExit(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "exit";
            break;
          case "fullscreen":
            element = createFullscreen(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "fullscreen";
            break;
          case "popscreen":
            bPopScreen = true;
            element = createPopscreen(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
          case "view":
            element = createView(folderName, obj);
            uiMainArea.appendChild(element);
            eventID = "none";
            break;
          case "screen":
            element = document.getElementById(videoIds[0].id);
            break;
          case "screen1":
            element = document.getElementById(videoIds[1].id);
            break;
          case "screen2":
            element = document.getElementById(videoIds[2].id);
            break;
          case "panelbetwin":
            element = document.getElementById(id);
            break;
          case "machinetitle":
            element = createMachineTitle(folderName, obj);
            uiMainArea.appendChild(element);
            break;
          case "account":
            element = createAccountTitle(folderName, obj);
            uiMainArea.appendChild(element);
            break;
          case "coin":
            element = createCoin(folderName, obj);
            uiMainArea.appendChild(element);
            break;
          case "here":
            element = createHere(folderName, obj);
            uiMainArea.appendChild(element);
            element.style.display = "none";
            mHereAnimation = element;
            break;
          case "tianjing":
            element = createHere(folderName, obj);
            uiMainArea.appendChild(element);
            element.style.display = "none";
            mTianjing = element;
            break;
          default:
            element = createImg(folderName, obj);
            uiMainArea.appendChild(element);
            break;
        }
        // keep element
        uiElements.others[id] = element;

        mGameOthers[id] = {
          btnEvent: eventID,
          btn: element,
          Keyboard: keyboard,
          Img: img,
          ImgDown: imgDown,
          btnID: id,
        };
      } else {
        element = uiElements.others[id];
      }

      let opacity = 0.3;
      let disabled = true;
      switch (id) {
        case "selector":
          opacity = 0.3;
          disabled = true;
          break;
        case "point":
          opacity = 0.3;
          disabled = true;
          break;
        case "score":
          opacity = 0.3;
          disabled = true;
          break;
        case "scoremsg":
          opacity = 1;
          disabled = false;
          break;
        case "reload":
          opacity = 1;
          disabled = false;
          break;
        case "exit":
          opacity = 1;
          disabled = false;
          break;
        case "fullscreen":
          opacity = 1;
          disabled = false;
          break;
        case "mute":
          opacity = 1;
          disabled = false;
          break;
        case "screen":
          opacity = 1;
          disabled = false;
          break;
        case "machinetitle":
          opacity = 1;
          disabled = false;
          break;
        default:
          opacity = 0.3;
          disabled = true;
          break;
      }

      const pos = obj.hasOwnProperty("pos") ? obj["pos"].split(",") : [0, 0];
      const uiSize = obj.hasOwnProperty("size")
        ? obj["size"].split(",")
        : [0, 0];
      if (element) {
        element.style.position = "absolute";
        element.style.left = `${pos[0] * boundary.scaleX}px`;
        element.style.top = `${pos[1] * boundary.scaleY}px`;
        element.style.width = `${uiSize[0] * boundary.scaleX}px`;
        element.style.height = `${uiSize[1] * boundary.scaleY}px`;
        element.style.opacity = opacity;
        element.style.zIndex = `${zIndex}`;
        element.disabled = disabled;
      } else {
        console.log(`null element, id:${id}`);
      }
    }

    // sync value of point
    onInScoreTimesChanged(uiElements.others["selector"]);
    const fontSize = Math.floor(48 * boundary.scaleX);
    const paddingTop = Math.floor(10 * boundary.scaleY);
    // change fontSize of point/score/msg
    if (uiElements.others.hasOwnProperty("point")) {
      const uiPoint = uiElements.others["point"];
      uiPoint.style.fontSize = `${fontSize}px`;
      uiPoint.style.paddingTop = `${paddingTop}px`;
    }
    if (uiElements.others.hasOwnProperty("score")) {
      const uiScore = uiElements.others["score"];
      uiScore.style.fontSize = `${fontSize}px`;
      uiScore.style.paddingTop = `${paddingTop}px`;
    }
    if (uiElements.others.hasOwnProperty("scoremsg")) {
      const uiScoreMsg = uiElements.others["scoremsg"];
      uiScoreMsg.style.fontSize = `${fontSize}px`;
      uiScoreMsg.style.paddingTop = `${paddingTop}px`;
    }
    if (uiElements.others.hasOwnProperty("machinetitle")) {
      const uiMachineTitle = uiElements.others["machinetitle"];
      const titleFontSize = Math.floor(fontSize * 1.2);
      const titlePaddingTop = Math.floor(paddingTop * 1.5);
      for (let i = 0; i < uiMachineTitle.children.length; i++) {
        const child = uiMachineTitle.children[i];
        if (!child.innerText) continue;
        child.style.fontSize = `${titleFontSize}px`;
        child.style.paddingTop = `${titlePaddingTop}px`;
      }
    }
    if (bPopScreen) {
      const uiView = document.getElementById(videoIds[2].id);
      uiView.hidden = true;
    }
  }

  function setGameBtns(gamebtns, boundary, folderName, uiMainArea) {
    const machineInfo = AppCtrl.spyMachineInfo();
    const btnHoldType = machineInfo.btnHoldType;
    const btnPinponTimers = machineInfo.btnPinponTimers;
    // do sort to make sure btn order are matched to manager's prefered order
    gamebtns.sort(function (a, b) {
      if (a.index < b.index) return -1;
      else return 1;
    });

    // create btns by order
    for (let i = 0; i < gamebtns.length; i++) {
      const obj = gamebtns[i];
      const id = obj["id"];
      const pos = obj.hasOwnProperty("pos") ? obj["pos"].split(",") : [0, 0];
      const uiSize = obj.hasOwnProperty("size")
        ? obj["size"].split(",")
        : [0, 0];

      let element = null;
      if (!uiElements.btns[id]) {
        const text = obj["text"];
        const index = obj["index"];
        const img = obj["Img"];
        const imgDown = obj["ImgDown"];
        const pushpinpos = obj.hasOwnProperty("pushpinpos")
          ? obj["pushpinpos"].split(",")
          : [0, 0];
        const pushpinsize = obj.hasOwnProperty("pushpinsize")
          ? obj["pushpinsize"].split(",")
          : [0, 0];
        const keyboard = obj.hasOwnProperty("Keyboard") ? obj["Keyboard"] : "";

        // create element
        element = createImgBtn(folderName, obj);
        element.disabled = true;
        element.style.opacity = 0.3;
        uiMainArea.appendChild(element);
        // keep element
        uiElements.btns[id] = element;
        // keep btnInfo in mGameBtns
        mGameBtns[id] = {
          btnStatus: defGameBtnStatusUP,
          btnHoldType: btnHoldType ? btnHoldType[i] : 0,
          timeoutLongPressed: null,
          pinponTimer: null,
          pinponTimerInterval: btnPinponTimers ? btnPinponTimers[i] : 500,
          Text: text,
          Index: index,
          Img: img,
          ImgDown: imgDown,
          PushpinPos: pushpinpos,
          PushpinSize: pushpinsize,
          btn: element,
          Keyboard: keyboard,
          btnID: id,
        };
      } else {
        element = uiElements.btns[id];
      }
      element.style.position = "absolute";
      element.style.left = `${pos[0] * boundary.scaleX}px`;
      element.style.top = `${pos[1] * boundary.scaleY}px`;
      element.style.width = `${uiSize[0] * boundary.scaleX}px`;
      element.style.height = `${uiSize[1] * boundary.scaleY}px`;
    }
  }

  function buildGameUI(deviceWidth, deviceHeight, uiConfig) {
    const uiMainArea = document.getElementById("mainArea");
    // if config exists, do layout
    if (uiConfig) {
      const folderName = uiConfig.hasOwnProperty("foldername")
        ? uiConfig["foldername"]
        : "huga";
      const machine = uiConfig["machine"];
      const gameothers = uiConfig["gameothers"];
      const gamebtns = uiConfig["gamebtns"];

      let logicUIWidth;
      let logicUIHeight;
      let realUIWidth;
      let realUIHeight;
      let wScale;
      let hScale;

      if (uiConfig.hasOwnProperty("size")) {
        const uiSize = uiConfig["size"].split(",");
        logicUIWidth = uiSize[0];
        logicUIHeight = uiSize[1];
      } else {
        logicUIWidth = 1920;
        logicUIHeight = 1080;
      }

      const ratioScreen = deviceWidth / deviceHeight;
      const ratioUI = logicUIWidth / logicUIHeight;
      if (ratioScreen > ratioUI) {
        // keep blank at left & right
        realUIHeight = deviceHeight;
        realUIWidth = realUIHeight * ratioUI;
      } else {
        // keep blank at top & bottom
        realUIWidth = deviceWidth;
        realUIHeight = realUIWidth / ratioUI;
      }
      wScale = realUIWidth / logicUIWidth;
      hScale = realUIHeight / logicUIHeight;

      if (uiMainArea) {
        const boundary = {
          x: (deviceWidth - realUIWidth) / 2,
          y: (deviceHeight - realUIHeight) / 2,
          w: realUIWidth,
          h: realUIHeight,
          scaleX: wScale,
          scaleY: hScale,
        };
        uiMainArea.style.left = `${boundary.x}px`;
        uiMainArea.style.top = `${boundary.y}px`;
        uiMainArea.style.width = `${boundary.w}px`;
        uiMainArea.style.height = `${boundary.h}px`;
        uiMainArea.style.display = "";

        if (machine) setMachine(machine, boundary, folderName);
        if (gameothers)
          setGameOthers(gameothers, boundary, folderName, uiMainArea);
        if (gamebtns) setGameBtns(gamebtns, boundary, folderName, uiMainArea);
      }
      console.log(`buildGameUI`);
    } else {
      if (uiMainArea) uiMainArea.style.display = "none";
    }
  }

  function onOtherBtnDown(e) {
    //預防常壓按鈕後跳出下載圖片事件
    e.preventDefault();
  }

  function registerEvent() {
    // trigger onResize to do layout
    window.addEventListener("resize", onResize);

    setTimeout(function () {
      const uiLoadingMask = document.getElementById("loadingmask");
      if (uiLoadingMask) uiLoadingMask.style.display = "none";
      if (mHereAnimation) {
        mHereAnimation.style.display = "";
        setTimeout(function () {
          mHereAnimation.style.display = "none";
        }, 8000);
      }
      if (mTianjing) {
        mTianjing.style.display = "";
      }
    }, 4000);

    // const bMobileDevice = Utils.detectmob();
    // for (let key in mGameBtns) {
    //     const gameBtn = mGameBtns[key];
    //     //
    //     if (bMobileDevice) {
    //         gameBtn.btn.addEventListener('touchstart', onGameBtnDown);
    //         gameBtn.btn.addEventListener('touchend', onGameBtnUp);
    //     }
    //     else {
    //         gameBtn.btn.addEventListener('mousedown', onGameBtnDown);
    //         gameBtn.btn.addEventListener('mouseup', onGameBtnUp);
    //     }
    // }

    // for (let key1 in mGameOthers) {
    //     const otherBtn = mGameOthers[key1];
    //     let eventID = otherBtn.btnEvent;
    //     if(eventID != 'none')
    //     {
    //         if (bMobileDevice) {
    //             otherBtn.btn.addEventListener('touchstart', eval(eventID));
    //         }
    //         else {
    //             otherBtn.btn.addEventListener('mousedown', eval(eventID));
    //         }
    //     }
    // }

    // if (!bMobileDevice && isKeyboardEnable) {
    //     document.addEventListener('keydown', onGameBtnDown);
    //     document.addEventListener('keyup', onGameBtnUp);
    //     document.addEventListener('keydown', KeyboardDown);
    // }
  }

  function unregisterEvent() {
    window.removeEventListener("resize", onResize);

    const uiMainArea = document.getElementById("mainArea");
    if (!uiMainArea) return;
    let uiloadingmask = document.getElementById("loadingmask");
    if (uiloadingmask) uiMainArea.removeChild(uiloadingmask);
    // clear long pressed event
    // const bMobileDevice = Utils.detectmob();
    // for (let key in mGameBtns) {
    //     const gameBtn = mGameBtns[key];
    //     if (gameBtn.pinponTimer) {
    //         clearInterval(gameBtn.pinponTimer);
    //         gameBtn.pinponTimer = null;
    //     }
    //     //
    //     if (bMobileDevice) {
    //         gameBtn.btn.removeEventListener('touchstart', onGameBtnDown);
    //         gameBtn.btn.removeEventListener('touchend', onGameBtnUp);
    //     }
    //     else {
    //         gameBtn.btn.removeEventListener('mousedown', onGameBtnDown);
    //         gameBtn.btn.removeEventListener('mouseup', onGameBtnUp);
    //     }
    // }
    mGameBtns = {};

    // for (let key1 in mGameOthers) {
    //     const otherBtn = mGameOthers[key1];
    //     let eventID = otherBtn.btnEvent;
    //     if (eventID != 'none') {
    //         if (bMobileDevice) {
    //             otherBtn.btn.removeEventListener('touchstart', eval(eventID));
    //         }
    //         else {
    //             otherBtn.btn.removeEventListener('mousedown', eval(eventID));
    //         }
    //     }
    // }
    // mGameOthers = {};

    // if (!bMobileDevice && isKeyboardEnable) {
    //     document.removeEventListener('keydown', onGameBtnDown);
    //     document.removeEventListener('keyup', onGameBtnUp);
    //     document.removeEventListener('keydown', KeyboardDown);
    // }
  }

  function decryptByDESModeCBC(ciphertext2) {
    var keyHex = CryptoJS.enc.Utf8.parse("95279527");
    var ivHex = CryptoJS.enc.Utf8.parse("95279527");
    // direct decrypt ciphertext
    var decrypted = CryptoJS.DES.decrypt(
      {
        ciphertext: CryptoJS.enc.Hex.parse(ciphertext2),
      },
      keyHex,
      {
        iv: ivHex,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      }
    );
    return decrypted.toString(CryptoJS.enc.Utf8);
  }

  function startVideo(uiIndex, videoSource, videoAngle) {
    const gameVideoId = videoIds[uiIndex].iframe;
    const uiGameVideo = document.getElementById(gameVideoId);

    if (uiGameVideo) {
      const keyWord = "://";
      let index = videoSource.indexOf(keyWord);
      if (index >= 0) videoSource = videoSource.substr(index + keyWord.length);

      let strSourceParams = videoSource.split("/");
      let videoDomain = strSourceParams[0];
      index = videoDomain.indexOf(":");

      if (index >= 0) videoDomain = videoDomain.substr(0, index);

      let videoUrl = `${videoDomain}`;

      let videoId;
      let sVideoId;
      if (AppCtrl.strEncrypt() === true) {
        var ciphertext = strSourceParams[strSourceParams.length - 1];
        sVideoId = strSourceParams[strSourceParams.length - 1];
        var sData = decryptByDESModeCBC(ciphertext);
        console.log(sData);
      } else {
        sVideoId = strSourceParams[strSourceParams.length - 1];
        videoId = parseInt(sVideoId);
      }

      // rebuild video source
      for (let i = 1; i < strSourceParams.length; i++) {
        videoUrl += `/${strSourceParams[i]}`;
      }

      //let url = `http://${videoDomain}/?id=${videoId}`;
      let url = `${protocolRef.current}://${videoDomain}/?id=${sVideoId}`;
      //url += '&controls=0&autostart=true&muted=true';
      url += "&autostart=true&muted=true";

      uiGameVideo.src = url;
      uiGameVideo.style.display = "";
      uiGameVideo.style.objectFit = "fill";
      //處理自動撥放,iOS的部分就是把下面參數放到SRS html的<video></video>裡面即可

      uiGameVideo.setAttribute("playsinline", null);
      uiGameVideo.setAttribute("WebKitPlaysInline", null);
      //uiGameVideo.controls = "controls";
      //uiGameVideo.controls = "false";
      uiGameVideo.autoplay = "autoplay";
      uiGameVideo.WebKitPlaysInline = true;
      uiGameVideo.playsinline = true;
      uiGameVideo.preload = "auto";
      uiGameVideo.muted = "true";

      //////////////////////////////////
      //畫面旋轉部分
      //uiGameVideo.style.transform = `rotate(${videoAngle}deg)`;
      if (uiIndex === 0) {
        const checkOrientation = AppCtrl.CheckOrientation();
        if (checkOrientation) {
          if (videoAngle != 0 && videoAngle != 180) {
            AppCtrl.LandscapePortraitSet(ScreenOrientation.PortraitPrimary);
          } else {
            AppCtrl.LandscapePortraitSet(ScreenOrientation.LandscapePrimary);
          }
        }
      }
      ////////////////////////////
    }
  }

  function stopVideo(uiIndex) {
    const gameVideoId = videoIds[uiIndex].iframe;
    const uiGameVideo = document.getElementById(gameVideoId);
    if (uiGameVideo) {
      uiGameVideo.src = "";
      uiGameVideo.style.display = "none";
    }
  }

  function displayElement(Display) {
    for (let key1 in mGameOthers) {
      const otherBtn = mGameOthers[key1];
      const ElementID = otherBtn.btnID;
      //otherBtn.btn.style.opacity = 0.1;
      //otherBtn.btn.display = Display;

      if (
        ElementID !== "exit" &&
        ElementID !== "popscreen" &&
        ElementID != "screen" &&
        ElementID != "screen1" &&
        ElementID != "screen2" &&
        ElementID != "machinetitle"
      ) {
        const uiElement = document.getElementById(ElementID);
        if (uiElement) uiElement.hidden = !Display;
      }
    }

    for (let key in mGameBtns) {
      const gameBtn = mGameBtns[key];
      const ElementID = gameBtn.btnID;
      const uiElement = document.getElementById(ElementID);
      if (uiElement) uiElement.hidden = !Display;
    }
  }

  function popScreen(e) {
    if (mMSDisplayIndex != 2) mMSDisplayIndex = 2;
    else mMSDisplayIndex = 0;
    if (mMSDisplayIndex === 2) {
      displayElement(false);
      const uiView0 = document.getElementById(videoIds[0].id);
      uiView0.hidden = true;
      const uiView1 = document.getElementById(videoIds[1].id);
      uiView1.hidden = true;
      const uiView2 = document.getElementById(videoIds[2].id);
      uiView2.hidden = false;
      const uiExit = document.getElementById("exit");
      if (uiExit) uiExit.style.opacity = 0.3;
      const uiPopscreen = document.getElementById("popscreen");
      if (uiPopscreen) uiPopscreen.style.opacity = 0.3;
    } else {
      displayElement(true);
      const uiView0 = document.getElementById(videoIds[0].id);
      uiView0.hidden = false;
      const uiView1 = document.getElementById(videoIds[1].id);
      uiView1.hidden = false;
      const uiView2 = document.getElementById(videoIds[2].id);
      uiView2.hidden = true;
      const uiExit = document.getElementById("exit");
      if (uiExit) uiExit.style.opacity = 1.0;
      const uiPopscreen = document.getElementById("popscreen");
      if (uiPopscreen) uiPopscreen.style.opacity = 1.0;
    }
  }

  function switchView() {
    // switch mVideoUIIndex
    mVideoUIIndex = (mVideoUIIndex + 1) % mVideoUINum;

    const bounds = [];
    for (let i = 0; i < mVideoUINum; i++) {
      const index = (i + 1) % mVideoUINum;
      const uiView = document.getElementById(videoIds[index].id);
      bounds.push({
        left: uiView.style.left,
        top: uiView.style.top,
        width: uiView.style.width,
        height: uiView.style.height,
      });
    }
    for (let i = 0; i < mVideoUINum; i++) {
      const uiView = document.getElementById(videoIds[i].id);
      uiView.style.left = bounds[i].left;
      uiView.style.top = bounds[i].top;
      uiView.style.width = bounds[i].width;
      uiView.style.height = bounds[i].height;
    }
  }

  let isFullScreen = false;
  function fullscreen(e) {
    isFullScreen = !isFullScreen;
    Utils.enterFullScreen();
    /*
        if (isFullScreen == true) {
            Utils.enterFullScreen();
        }
        else {
            Utils.exitFullScreen();
        }
        */
    //預防常壓按鈕後跳出下載圖片事件
    e.preventDefault();
  }

  function KeyboardDown(e) {
    e.preventDefault();
    // let btnId = null;
    // let gameOtherBtn;
    // if (e.type == 'keydown') {
    //     const key = e.key;

    //     for (let id in mGameOthers) {
    //         gameOtherBtn = mGameOthers[id];
    //         if (key == gameOtherBtn.Keyboard) {
    //             btnId = id;
    //             break;
    //         }
    //     }
    //     if (btnId === null || !gameOtherBtn)
    //         return;

    //     console.log('exit-Keyboard');
    //     console.log(`key=${e}.key},code=${e.code}`);

    //     switch (btnId) {
    //         case 'exit':
    //             exit(e);

    //             break;
    //         case 'popscreen':
    //             popScreen(e);

    //             break;
    //         case 'view':
    //             viewVideo(e);

    //             break;
    //         case 'fullscreen':
    //             fullscreen(e);

    //             break;
    //         case 'reload':
    //             doReload();

    //             break;
    //         default:

    //             break;
    //     }
    // }
  }

  return (
    <div className={styles.gamePlayClassic}>
      <div id="mainArea" className={styles.mainArea}>
        <GameBG bgImgId={bgImgId} />
        <VideoPanel info={videoIds[0]} />
        <VideoPanel info={videoIds[1]} />
        <VideoPanel info={videoIds[2]} />
        <div id="panelbetwin">
          {Object.values(betWinData).length > 0 ? (
            <BetWinPanel
              betWinData={betWinData}
              roundIndex={roundIndex}
              setRoundIndex={setRoundIndex}
            />
          ) : null}
        </div>
      </div>
    </div>
  );
}

export default GameSpyClassic;
